import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/pages/login/login.vue'
import Register from '@/pages/register/register.vue'
import Store from '@/pages/store/store.vue'
import AddStore from '@/pages/addStore/addStore.vue'
import Index from '@/pages/index/index.vue'

// index routers
import Home from '@/components/indexRouters/home/home.vue'
import Statement from '@/components/indexRouters/statement/statement.vue'//报表
import Employee from '@/components/indexRouters/employee/employee.vue'//员工列表
import wechatList from '@/components/indexRouters/employee/wechatList.vue'//微信通知列表
import achievement from '@/components/indexRouters/employee/achievement.vue'//员工业绩
import Jobs from '@/components/indexRouters/jobs/jobs.vue'//岗位
import vipMan from '@/components/indexRouters/vipMan/vipMan.vue'//会员资料
import lostVip from '@/components/indexRouters/vipMan/lostVip.vue'//流失会员
import vipCons from '@/components/indexRouters/vipMan/vipCons.vue'//会员消费记录
import chargeInfo from '@/components/indexRouters/vipMan/chargeInfo.vue'//会员充值记录
import vipRecharge from '@/components/indexRouters/vipMan/vipRecharge.vue'//会员充值规则记录
import wechatOrder from '@/components/indexRouters/vipMan/wechatOrder.vue'//微信点单列表
// import invAdd from '@/components/indexRouters/inventory/addGoods.vue'//商品入库
// import invList from '@/components/indexRouters/inventory/invList.vue'//盘点历史
// import invDetails from '@/components/indexRouters/inventory/details.vue'//库存详情
// import invDestroy from '@/components/indexRouters/inventory/destroy.vue'//商品报损
// import invWarning from '@/components/indexRouters/inventory/warning.vue'//库存预警
import exchangeWork from '@/components/indexRouters/saleInfo/exchangeWork/exchangeWork.vue'//交接班记录
import exchangeWorkNew from '@/components/indexRouters/saleInfo/exchangeWork/exchangeWorkNew.vue'//交接班记录
import settleCount from '@/components/indexRouters/saleInfo/settleCount/settleCount.vue'//
import staffGrade from '@/components/indexRouters/saleInfo/exchangeWork/subpages/staffGrade'//员工的对账单
import dailyGrade from '@/components/indexRouters/saleInfo/dailyGrade/dailyGrade.vue'//对账单
import ringReport from '@/components/indexRouters/saleInfo/ringReport/ringReport.vue'//同期报表
import rewardInfo from '@/components/indexRouters/callAndReward/rewardInfo/rewardInfo.vue'//打赏记录
import ratingInfo from '@/components/indexRouters/callAndReward/ratingInfo/ratingInfo.vue'//打赏记录
import getWithdraw from '@/components/indexRouters/callAndReward/getWithdraw/getWithdraw.vue'//
import putWithdraw from '@/components/indexRouters/callAndReward/putWithdraw/putWithdraw.vue'//
import setWithdraw from '@/components/indexRouters/callAndReward/setWithdraw/setWithdraw.vue'//
import dlCall from '@/components/indexRouters/callAndReward/dlCall/dlCall.vue'//
import totalSales from '@/components/indexRouters/saleInfo/totalSales/totalSales.vue'//
import elecSales from '@/components/indexRouters/saleInfo/elecSales/elecSales.vue'//
import stockSummary from '@/components/indexRouters/saleInfo/stockSummary/stockSummary.vue'//
import stockData from '@/components/indexRouters/saleInfo/stockData/stockData.vue'//
import orderSearch from '@/components/indexRouters/saleInfo/orderSearch/orderSearch.vue'//
import goodsInfo from '@/components/indexRouters/goods/info.vue'//商品资料
import spec from '@/components/indexRouters/goods/spec.vue'//商品资料
import goodsLog from '@/components/indexRouters/goods/goodsLog.vue'//商品资料
import goodsClassify from '@/components/indexRouters/goods/classify.vue'//商品分类
import goodsInterval from '@/components/indexRouters/goods/interval.vue'//商品时段
import merCert from '@/components/indexRouters/MerchantInformation/merCert.vue'//商户认证
// import keyCert from '@/components/indexRouters/MerchantInformation/keyCert.vue'//秘钥认证
import topUp from '@/components/indexRouters/topUp/topUp.vue'//充值中心
import createCode from '@/components/indexRouters/createCode/createCode.vue'//创建二维码
import setting from '@/components/indexRouters/setting/setting.vue'//创建二维码
import addcoupon from '@/components/indexRouters/coupon/addcoupon.vue'//优惠券
import couponDetail from '@/components/indexRouters/coupon/coupondetail.vue'//优惠券
import couponProfile from '@/components/indexRouters/coupon/couponProfile.vue'//优惠券
import verifiCoupon from '@/components/indexRouters/coupon/verifiCoupon.vue'//优惠券

import voucher from '@/components/indexRouters/voucher/voucher.vue'//优惠券
//语音呼叫设置界面
import voiceCall from "@/components/indexRouters/voiceCall/voiceCall.vue";
import market from "@/components/indexRouters/market/market.vue";
import address from "@/components/indexRouters/market/address.vue";
import orderInfo from "@/components/indexRouters/market/orderInfo.vue";


// 活动
import second from '@/components/indexRouters/activity/second/second.vue'//商品时段
import modifySecond from '@/components/indexRouters/activity/second/modifySecond/index.vue'//商品时段
// 
import matUnit from '@/components/indexRouters/material/matUnit.vue'//商品时段
import matGoods from '@/components/indexRouters/material/matGoods.vue'//商品时段
import peiGoods from '@/components/indexRouters/peiGoods/info.vue'//商品时段

import region from '@/components/indexRouters/computer/region.vue'//
import waitRegion from '@/components/indexRouters/waitSite/region.vue'//
import regionType from '@/components/indexRouters/waitSite/regionType.vue'//
import site from '@/components/indexRouters/computer/site.vue'//
import catchRateGoods from '@/components/indexRouters/goods/catchRateGoods.vue'//
import bigScreenGoods from '@/components/indexRouters/goods/bigScreenGoods.vue'//
import bigScreen from '@/components/bigScreen/index.vue'//
import bigScreenFrontEnd from '@/components/bigScreenFrontEnd/index.vue'//
import bigScreenFrontEndWithoutAutoScreen from '@/components/bigScreenFrontEndWithoutAutoScreen/index.vue'//
import goodsBigScreen from '@/components/goodsBigScreen/index.vue'//
import rentCate from '@/components/indexRouters/rent/cate/index.vue'//
import rentGoods from '@/components/indexRouters/rent/goods/index.vue'//
import rentRule from '@/components/indexRouters/rent/ruleMana/index.vue'//
import rentOrder from '@/components/indexRouters/rent/rentOrder/rentOrder.vue'//
import rentDetail from '@/components/indexRouters/rent/rentDetail/rentDetail.vue'//
import rentHello from '@/components/indexRouters/rent/hello/index.vue'//
import goodsLogForRent from '@/components/indexRouters/rent/goodsLog/goodsLog.vue'//商品资料

Vue.use(Router)

export default new Router({
    routes: [{
        //重定向
        path: '*',
        redirect: '/login',
        meta:{
            isKeep:false,
        }
    }, {
        path: '/login',
        name: 'login',
        component: Login,
        meta:{
            isKeep:false,
        }
    }, {
        path: '/register/:foo',
        name: 'register',
        component: Register,
        meta:{
            isKeep:false,
        }
    },{
        path: '/register',
        name: 'register',
        component: Register,
        meta:{
            isKeep:false,
        }
    }, {
        path: '/store',
        name: 'store',
        component: Store,
        meta:{
            isKeep:false,
        }
    }, {
        path: '/sys/:id',
        name: 'sys',
        redirect: '/sys/:id/Statement',
        component: Index,
        children: [
            {
                path: '/sys/:id/rentRule',
                name: 'rentRule',
                component: rentRule,
                meta:{
                    isKeep:false,
                    tabName:'计费规则',
                }
            },
            {
                path: '/sys/:id/rentHello',
                name: 'rentHello',
                component: rentHello,
                meta:{
                    isKeep:false,
                    tabName:'计费规则',
                }
            },
            {
                path: '/sys/:id/rentDetail',
                name: 'rentDetail',
                component: rentDetail,
                meta:{
                    isKeep:false,
                    tabName:'租赁明细',
                }
            },
            {
                path: '/sys/:id/rentOrder',
                name: 'rentOrder',
                component: rentOrder,
                meta:{
                    isKeep:false,
                    tabName:'租赁明细',
                }
            },
            {
                path: '/sys/:id/rentCate',
                name: 'rentCate',
                component: rentCate,
                meta:{
                    isKeep:false,
                    tabName:'分类管理',
                }
            },
            {
                path: '/sys/:id/rentGoods',
                name: 'rentGoods',
                component: rentGoods,
                meta:{
                    isKeep:false,
                    tabName:'商品管理',
                }
            },
            {
                path: '/sys/:id/bigScreenGoods',
                name: 'bigScreenGoods',
                component: bigScreenGoods,
                meta:{
                    isKeep:false,
                    tabName:'排单机',
                }
            },
            {
                path: '/sys/:id/goodsBigScreen',
                name: 'goodsBigScreen',
                component: goodsBigScreen,
                meta:{
                    isKeep:true,
                    tabName:'排单机',
                }
            },
            {
                path: '/sys/:id/catchRateGoods',
                name: 'catchRateGoods',
                component: catchRateGoods,
                meta:{
                    isKeep:true,
                    tabName:'捕获率商品',
                }
            },
            {
                path: '/sys/:id/matUnit',
                name: 'matUnit',
                component: matUnit,
                meta:{
                    isKeep:true,
                    tabName:'原料单位管理',
                }
            },
            {
                path: '/sys/:id/matGoods',
                name: 'matGoods',
                component: matGoods,
                meta:{
                    isKeep:true,
                    tabName:'原料商品管理',
                }
            },
            {
                path: '/sys/:id/region',
                name: 'region',
                component: region,
                meta:{
                    isKeep:true,
                    tabName:'区域管理',
                }
            },
            {
                path: '/sys/:id/regionType',
                name: 'regionType',
                component: regionType,
                meta:{
                    isKeep:true,
                    tabName:'区域分类',
                }
            },
            {
                path: '/sys/:id/waitRegion',
                name: 'waitRegion',
                component: waitRegion,
                meta:{
                    isKeep:true,
                    tabName:'排号管理',
                }
            },
            {
                path: '/sys/:id/site',
                name: 'site',
                component: site,
                meta:{
                    isKeep:true,
                    tabName:'机位设置',
                }
            },
            // 
            {
                path: '/sys/:id/bigScreen',
                name: 'site',
                component: bigScreen,
                meta:{
                    isKeep:true,
                    tabName:'机位大屏',
                }
            },
            {
                path: '/sys/:id/bigScreenFrontEnd',
                name: 'bigScreenFrontEnd',
                component: bigScreenFrontEnd,
                meta:{
                    isKeep:true,
                    tabName:'机位大屏',
                }
            },
            {
                path: '/sys/:id/bigScreenFrontEndWithoutAutoScreen',
                name: 'bigScreenFrontEndWithoutAutoScreen',
                component: bigScreenFrontEndWithoutAutoScreen,
                meta:{
                    isKeep:true,
                    tabName:'机位大屏',
                }
            },
            // 
            {
                path: '/sys/:id/peiGoods',
                name: 'peiGoods',
                component: peiGoods,
                meta:{
                    isKeep:true,
                    tabName:'配品列表',
                }
            },
        	{
                path: '/sys/:id/home',
                name: 'home',
                component: Home,
                meta:{
                    isKeep:false,
                }
            },
            {
                path: '/sys/:id/Statement',
                name: 'Statement',
                component: Statement,
                meta:{
                    tabName:'店铺报表',
                    isKeep:true
                }
            },
            {
                path: '/sys/:id/addcoupon',
                name: 'addcoupon',
                component: addcoupon,
                meta:{
                    tabName:'创建中心',
                    isKeep:true

                }
            },{
                path: '/sys/:id/couponProfile',
                name: 'couponProfile',
                component: couponProfile,
                meta:{
                    tabName:'优惠券详情',
                    isKeep:false

                }
            },{
                path: '/sys/:id/couponDetail',
                name: 'couponDetail',
                component: couponDetail,
                meta:{
                    tabName:'派发记录',
                    isKeep:true

                }
            },
            {
                path: '/sys/:id/verifiCoupon',
                name: 'verifiCoupon',
                component: verifiCoupon,
                meta:{
                    tabName:'核销详情',
                    isKeep:true
                }
            },
            {
                path: '/sys/:id/voucher',
                name: 'voucher',
                component: voucher,
                meta:{
                    tabName:'',
                    isKeep:false
                }
            }
            ,{
                path: '/sys/:id/employee',
                name: 'employee',
                component: Employee,
                meta:{
                    tabName:'员工列表',
                    isKeep:true
                }
            },{
                path: '/sys/:id/wechatList',
                name: 'wechatList',
                component: wechatList,
                meta:{
                    tabName:'微信通知',
                    isKeep:true
                }
            },{
                path: '/sys/:id/achievement',
                name: 'achievement',
                component: achievement,
                meta:{
                    tabName:'员工业绩',
                    isKeep:true

                }
            },
            {
                path: '/sys/:id/jobs',
                name: 'jobs',
                component: Jobs,
                meta:{
                    tabName:'岗位设置',
                    isKeep:true
                }
            },
            {
                path: '/sys/:id/vipMan',
                name: 'vipMan',
                component: vipMan,
                meta:{
                    tabName:'',
                    isKeep:false
                }
            },
            {
                path: '/sys/:id/lostVip/:type',
                name: 'lostVip',
                component: lostVip,
                meta:{
                    tabName:'会员资料',
                    isKeep:true
                }
            },
            {
                path: '/sys/:id/vipCons',
                name: 'vipCons',
                component: vipCons,
                meta:{
                    tabName:'',
                    isKeep:false
                }
            },
            {
                path: '/sys/:id/vipRecharge',
                name: 'vipRecharge',
                component: vipRecharge,
                meta:{
                    tabName:'会员充值规则',
                    isKeep:true
                }
            },
            {
                path: '/sys/:id/chargeInfo',
                name: 'chargeInfo',
                component: chargeInfo,
                meta:{
                    tabName:'会员充值记录',
                    isKeep:true
                }
            },{
                path: '/sys/:id/wechatOrder',
                name: 'wechatOrder',
                component: wechatOrder,
                meta:{
                    tabName:'微信点单',
                    isKeep:true
                }
            },
            // {
            //     path: '/sys/:id/invList',
            //     name: 'invList',
            //     component: invList
            // },{
            //     path: '/sys/:id/invDetails',
            //     name: 'invDetails',
            //     component: invDetails
            // },{
            //     path: '/sys/:id/invDestroy',
            //     name: 'invDestroy',
            //     component: invDestroy
            // },{
            //     path: '/sys/:id/invWarning',
            //     name: 'invWarning',
            //     component: invWarning
            // },{
            //     path: '/sys/:id/invAdd',
            //     name: 'invAdd',
            //     component: invAdd
            // },
            {
                path: '/sys/:id/exchangeWork',
                name: 'exchangeWork',
                component: exchangeWork,
                meta:{
                    tabName:'交接班记录',
                    isKeep:true
                },
                children:[
                    {
                        path: '/sys/:id/exchangeWork/staffGrade',
                        name: 'staffGrade',
                        component: staffGrade,
                        meta:{
                            tabName:'交接班详情',
                            isKeep:false
                        }
                    }
                ]
            },{
                path: '/sys/:id/dailyGrade',
                name: 'dailyGrade',
                component: dailyGrade,
                meta:{
                    tabName:'对账单',
                    isKeep:true
                }
            },{
                path: '/sys/:id/exchangeWorkNew',
                name: 'exchangeWorkNew',
                component: exchangeWorkNew,
                meta:{
                    tabName:'班次销售统计',
                    isKeep:true
                }
            },{
                path: '/sys/:id/settleCount',
                name: 'settleCount',
                component: settleCount,
                meta:{
                    tabName:'结算查询',
                    isKeep:true
                }
            },{
                path: '/sys/:id/ringReport',
                name: 'ringReport',
                component: ringReport,
                meta:{
                    tabName:'同期日报表',
                    isKeep:true
                }
            },{
                path: '/sys/:id/rewardInfo',
                name: 'rewardInfo',
                component: rewardInfo,
                meta:{
                    tabName:'打赏记录',
                    isKeep:true
                }
            },{
                path: '/sys/:id/ratingInfo',
                name: 'ratingInfo',
                component: ratingInfo,
                meta:{
                    tabName:'评价记录',
                    isKeep:true
                }
            },{
                path: '/sys/:id/getWithdraw',
                name: 'getWithdraw',
                component: getWithdraw,
                meta:{
                    tabName:'提现记录',
                    isKeep:true
                }
            },{
                path: '/sys/:id/putWithdraw',
                name: 'putWithdraw',
                component: putWithdraw,
                meta:{
                    tabName:'我要提现',
                    isKeep:true
                }
            },{
                path: '/sys/:id/setWithdraw',
                name: 'setWithdraw',
                component: setWithdraw,
                meta:{
                    tabName:'设置提现信息',
                    isKeep:true
                }
            },{
                path: '/sys/:id/dlCall',
                name: 'dlCall',
                component: dlCall,
                meta:{
                    tabName:'语音软件下载',
                    isKeep:true
                }
            },{
                path: '/sys/:id/orderSearch',
                name: 'orderSearch',
                component: orderSearch,
                meta:{
                    tabName:'',
                    isKeep:false
                }
            },{
                path: '/sys/:id/totalSales',
                name: 'totalSales',
                component: totalSales,
                meta:{
                    tabName:'销售汇总',
                    isKeep:true
                }
            },{
                path: '/sys/:id/elecSales',
                name: 'elecSales',
                component: elecSales,
                meta:{
                    tabName:'电子对账单',
                    isKeep:true
                }
            },{
                path: '/sys/:id/stockSummary',
                name: 'stockSummary',
                component: stockSummary,
                meta:{
                    tabName:'采购汇总',
                    isKeep:true
                }
            },{
                path: '/sys/:id/stockData',
                name: 'stockData',
                component: stockData,
                meta:{
                    tabName:'库存汇总',
                    isKeep:true
                }
            },{
                path: '/sys/:id/spec',
                name: 'spec',
                component: spec,
                meta:{
                    tabName:'规格管理',
                    isKeep:true
                }
            },{
                path: '/sys/:id/goodsInfo',
                name: 'goodsInfo',
                component: goodsInfo,
                meta:{
                    tabName:'商品资料',
                    isKeep:true
                }
            },{
                path: '/sys/:id/goodsLog',
                name: 'goodsLog',
                component: goodsLog,
                meta:{
                    tabName:'商品资料变动记录',
                    isKeep:true
                }
            },{
                path: '/sys/:id/goodsLogForRent',
                name: 'goodsLogForRent',
                component: goodsLogForRent,
                meta:{
                    tabName:'租赁商品变动记录',
                    isKeep:true
                }
            },{
                path: '/sys/:id/goodsClassify',
                name: 'goodsClassify',
                component: goodsClassify,
                meta:{
                    tabName:'商品分类',
                    isKeep:true
                }
            },{
                path: '/sys/:id/goodsInterval',
                name: 'goodsInterval',
                component: goodsInterval,
                meta:{
                    tabName:'销售时段管理',
                    isKeep:true
                }
            },
            {
                path: '/sys/:id/merCert',
                name: 'merCert',
                component: merCert,
                meta:{
                    tabName:'商户认证',
                    isKeep:true
                }
            },
            // {
            //     path: '/sys/:id/keyCert',
            //     name: 'keyCert',
            //     component: keyCert
            // },
            {
                path: '/sys/:id/topUp',
                name: 'topUp',
                component: topUp,
                meta:{
                    tabName:'',
                    isKeep:false
                }
            },{
                path: '/sys/:id/createCode',
                name: 'createCode',
                component: createCode,
                meta:{
                    tabName:'下载中心',
                    isKeep:true
                }
            },{
                path: '/sys/:id/setting',
                name: 'setting',
                component: setting,
                meta:{
                    tabName:'系统设置',
                    isKeep:true
                }
            },{
                path: '/sys/:id/voiceCall',
                name: 'voiceCall',
                component: voiceCall,
                meta:{
                    tabName:'',
                    isKeep:false
                }
            },{
                path: '/sys/:id/market',
                name: 'market',
                component: market,
                meta:{
                    tabName:'原料商城',
                    isKeep:true
                }
            },{
                path: '/sys/:id/address',
                name: 'address',
                component: address,
                meta:{
                    tabName:'收货地址',
                    isKeep:true
                }
            },{
                path: '/sys/:id/orderInfo',
                name: 'orderInfo',
                component: orderInfo,
                meta:{
                    tabName:'订单记录',
                    isKeep:true
                }
            },{
                path: '/sys/:id/second',
                name: 'second',
                component: second,
                meta:{
                    tabName:'第二份优惠',
                    isKeep:true
                }
            },{
                path: '/sys/:id/modifySecond',
                name: 'modifySecond',
                component: modifySecond,
                meta:{
                    tabName:'第二份优惠(新增/编辑)',
                    isKeep:true
                }
            }
        ]
    }, 
    {
        path: '/addStore',
        name: 'addStore',
        component: AddStore,
        meta:{
            tabName:'',
            isKeep:false
        }
    },{
        path: '/addStore/:isFirst',
        name: 'addStore',
        component: AddStore,
        meta:{
            tabName:'',
            isKeep:false
        }
    }, 
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js